// import { myStorage } from '@/utils';
import landingBanner from '@/assets/images/1/landing_banner.png';
import landingRepresentativeBg from '@/assets/images/1/landing_representative_bg.png';

export default {
  data() {
    return {
      userValue: '', // user框 (手机号/邮箱）
      passValue: '', // 密码框
      comfirmValue: '', // 确认密码框
      invitedValue: '', // 邀请码
    };
  },
  computed: {
    mainBg() {
      return `background-image: url(${landingBanner})`;
    },
    representativeBg() {
      return `background-image: url(${landingRepresentativeBg})`;
    },
  },
  methods: {
    goDownload() {
      this.$router.push('/appDownLoad');
    },
    goRegister(type) {
      // banner处注册 和 非banner处注册
      // banner注册 将填好的信息带过去
      if (type === 1) {
        this.$router.push({
          query: {
            phone: this.userValue,
            inviteCode: this.invitedValue,
          },
          path: '/register',
        });
      } else {
        this.$router.push('/register');
      }
    },
  },
};
